export class EweByMailRequest {
  communication: boolean;
  profiling: boolean;
  dataSharing: boolean;
  sendSummaryMail: boolean;
}
